import { createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "helpers";

export const getSlides = createAsyncThunk(
  "app/getSlides",
  async (_, thunkAPI) => {
    const { getState, rejectWithValue } = thunkAPI;
    try {
      const response = await client().get("getSliderData", {
        headers: {
          Language: getState().app.language,
        },
      });
      const data = response.data;
      return [...data.data].reverse();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getNews = createAsyncThunk("app/getNews", async (_, thunkAPI) => {
  const { getState, rejectWithValue } = thunkAPI;
  try {
    const response = await client().get("getNews", {
      headers: {
        Language: getState().app.language,
      },
    });
    const data = response.data;
    return data.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const getFacts = createAsyncThunk(
  "app/getFacts",
  async (_, thunkAPI) => {
    const { getState, rejectWithValue } = thunkAPI;
    try {
      const response = await client().get("getFacts", {
        headers: {
          Language: getState().app.language,
        },
      });
      const data = response.data;
      return data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSocialMediaLinks = createAsyncThunk(
  "app/getSocialMediaLinks",
  async (_, thunkAPI) => {
    const { getState, rejectWithValue } = thunkAPI;
    try {
      const response = await client().get("getSocialMediaLinks", {
        headers: {
          Language: getState().app.language,
        },
      });
      const data = response.data;
      return data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPublicPages = createAsyncThunk(
  "app/getPublicPages",
  async (_, thunkAPI) => {
    const { getState, rejectWithValue } = thunkAPI;
    try {
      const response = await client().get("getPublicPages", {
        headers: {
          Language: getState().app.language,
        },
      });
      const data = response.data;
      return data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getImportantLinks = createAsyncThunk(
  "app/getFooterImportantLinks",
  async (_, thunkAPI) => {
    const { getState, rejectWithValue } = thunkAPI;
    try {
      const response = await client().get("getFooterImportantLinks", {
        headers: {
          Language: getState().app.language,
        },
      });
      const data = response.data;
      return data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSettings = createAsyncThunk(
  "app/getSettings",
  async (_, thunkAPI) => {
    const { getState, rejectWithValue } = thunkAPI;
    try {
      const response = await client().get("getSettings", {
        headers: {
          Language: getState().app.language,
        },
      });
      const data = response.data;
      return data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
